const schemata = require('@clocklimited/schemata')
const required = require('@clocklimited/validity-required')

module.exports = () =>
  schemata({
    name: 'EditorialContactForm',
    properties: {
      firstName: { type: String, validators: [required] },
      lastName: { type: String, validators: [required] },
      phone: { type: String }
    }
  })
